import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import { DataIcon, AttractingIcon, AnalyticsIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const features = [
  {
    heading: `Modern customer data foundation`,
    description: `Power all your customer experiences with trusted, real-time, first-party customer data from Twilio Segment’s leading CDP.`,
    icon: <DataIcon />,
  },
  {
    heading: `Scalable native communications channels`,
    description: `Reach global customers using native channels built on the APIs trusted to send billions of communications every day.`,
    icon: <AttractingIcon />,
  },
  {
    heading: `Powerful, unified orchestration and analytics`,
    description: `Build, activate, and measure ROI from one platform to save time and budget while improving campaign performance and efficiency.`,
    icon: <AnalyticsIcon />,
  },
]

const copy = {
  heading: `Deliver unified, personalized customer experiences at scale`,
  description: `Twilio Engage uniquely puts the power of a native customer data platform (CDP) and native multichannel together in one marketing solution to help companies deliver data-driven personalization and drive efficient growth.`,
}

export const UnifiedCustomerExperiences = () => {
  return (
    <StyledSectionBase variant="centered">
      <StyledSectionCopy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </StyledSectionCopy>
      <Section.Contents>
        <ColumnTrack columns={1} overrides={{ md: 3 }}>
          {features.map((feature, index) => (
            <StyledFeatureBoxBase key={index} alignment="left" headerPosition="top">
              <FeatureBox.Header>
                <StyledIconWrapper variant="circle" background="light" elevation={1}>
                  {feature.icon}
                </StyledIconWrapper>
              </FeatureBox.Header>
              <FeatureBox.Body>
                <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                <FeatureBox.Text>{feature.description}</FeatureBox.Text>
              </FeatureBox.Body>
            </StyledFeatureBoxBase>
          ))}
        </ColumnTrack>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  max-width: 1280px;
`

const StyledSectionCopy = styled(Section.Copy)`
  max-width: 844px;
`

// NOTE: We don't have this particular combination of color/background in the theme yet, hence the override
const StyledIconWrapper = styled(IconWrapper)`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  max-width: 350px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: unset;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 0 15px;
  }

  ${({ theme }) => theme.breakpoints.up(`xxl`)} {
    padding: 24px 15px;
  }
`

export default UnifiedCustomerExperiences
